(function () {
  'use strict';

  const SELECTORS = {
    section: '[data-hb-chatboot-section]',
    openBtn: '[data-hb-chatboot-open]',
    overlay: '[data-hb-chatboot-overlay]',
    closeBtn: '[data-hb-chatboot-close]',
    modal: '[data-hb-chatboot-modal]',
    step: '[data-hb-chatboot-step]',
    option: '[data-hb-chatboot-option]',
    nextBtn: '[data-hb-chatboot-next]',
    backBtn: '[data-hb-chatboot-back]',
    dot: '[data-hb-chatboot-dot]',
    resultTitle: '[data-hb-chatboot-result-title]',
    resultSub: '[data-hb-chatboot-result-sub]',
    resultList: '[data-hb-chatboot-result-list]',
    restartBtn: '[data-hb-chatboot-restart]',
    browseBtn: '[data-hb-chatboot-browse]',
    mappingScript: '[data-hb-chatboot-mappings]',
  };

  let answers = [null, null, null];
  let currentResultHandles = [];
  let mappings = [];
  let persistentQuizHandles = null;

  /** Fallback mapping when no result_mapping blocks are configured.
   *  Mirrors the original qMap from the reference HTML/JS. */
  const FALLBACK_MAP = [
    {
      goal: 0,
      title: 'SEO & Visibility',
      sub: 'Start with understanding your search health.',
      k: ['seo', 'rank', 'google', 'traffic', 'organic', 'search', 'visibility', 'keywords', 'local'],
    },
    {
      goal: 1,
      title: 'Conversion Optimisation',
      sub: "Find what's stopping visitors from buying.",
      k: ['convert', 'conversion', 'cro', 'bounce', 'landing', 'sales', 'buy', 'visitors', 'audit', 'product page'],
    },
    {
      goal: 2,
      title: 'Paid Ads & Tracking',
      sub: 'Fix your ads and make sure your data is right.',
      k: ['google ads', 'ppc', 'ads', 'advertising', 'roas', 'campaign', 'paid', 'analytics', 'tracking', 'ga4', 'pixel'],
    },
    {
      goal: 3,
      title: 'Shopify Growth',
      sub: 'Optimise your store to sell more.',
      k: ['shopify', 'ecommerce', 'store', 'product', 'cart', 'launch', 'setup'],
    },
    {
      goal: 4,
      title: 'Design & Build',
      sub: 'Build something that converts from day one.',
      k: ['design', 'redesign', 'figma', 'brand', 'build', 'look', 'page', 'tracking', 'analytics'],
    },
  ];

  function getSection() {
    return document.querySelector(SELECTORS.section);
  }

  function getOverlay() {
    return document.querySelector(SELECTORS.overlay);
  }

  function loadMappings() {
    const script = document.querySelector(SELECTORS.mappingScript);
    if (!script) return;
    try {
      const data = JSON.parse(script.textContent);
      mappings = data.resultMappings || [];
    } catch (e) {
      mappings = [];
    }
  }

  function cardSearchBlob(card) {
    const fromAttr = card.getAttribute('data-hb-ai-search-text');
    if (fromAttr != null && fromAttr !== '') return fromAttr.toLowerCase();
    const title = card.querySelector('.cus-collection__product-title')?.textContent ?? '';
    const desc = card.querySelector('.cus-collection__product-desc')?.textContent ?? '';
    const tags = [...card.querySelectorAll('.cus-collection__product-tags')]
      .map((el) => el.textContent ?? '')
      .join(' ');
    return `${title} ${desc} ${tags}`.toLowerCase();
  }

  function findHandlesForGoal(goalIndex) {
    const fb = FALLBACK_MAP.find((x) => x.goal === goalIndex) || FALLBACK_MAP[0];
    const cards = [...document.querySelectorAll('.cus-collection__card')];
    if (!cards.length) return { title: fb.title, sub: fb.sub, handles: [] };

    const scores = [];
    cards.forEach((card) => {
      const handle = card.dataset.productHandle ?? '';
      if (!handle) return;
      const blob = cardSearchBlob(card);
      let score = 0;
      fb.k.forEach((kw) => {
        if (blob.includes(kw)) score += 10;
      });
      if (score > 0) scores.push({ handle, score });
    });

    scores.sort((a, b) => b.score - a.score);
    const handles = scores.slice(0, 3).map((s) => s.handle);

    if (!handles.length) {
      cards.slice(0, 3).forEach((card) => {
        const h = card.dataset.productHandle;
        if (h) handles.push(h);
      });
    }

    return { title: fb.title, sub: fb.sub, handles };
  }

  function openQuiz() {
    restartQuiz();
    const overlay = getOverlay();
    if (overlay) {
      overlay.classList.add('open');
      document.body.style.overflow = 'hidden';
    }
  }

  function closeQuiz() {
    const overlay = getOverlay();
    if (overlay) {
      overlay.classList.remove('open');
      document.body.style.overflow = '';
    }
  }

  function closeQuizBg(e) {
    const overlay = getOverlay();
    if (e.target === overlay) closeQuiz();
  }

  function goStep(stepIndex) {
    document.querySelectorAll(SELECTORS.step).forEach((el, i) => {
      el.classList.toggle('active', i === stepIndex);
    });

    for (let i = 0; i < 3; i++) {
      const dot = document.querySelector(`[data-hb-chatboot-dot="${i}"]`);
      if (dot) dot.classList.toggle('done', i < stepIndex);
    }
  }

  function pickOption(stepIndex, value, el) {
    const opts = el.closest('.hb-chatboot__list');
    if (!opts) return;
    opts.querySelectorAll('.hb-chatboot__card').forEach((o) => o.classList.remove('selected'));
    el.classList.add('selected');
    answers[stepIndex] = parseInt(value, 10);

    const nextBtn = document.querySelector(`[data-hb-chatboot-next="${stepIndex}"]`);
    if (nextBtn) nextBtn.disabled = false;
  }

  function getProductDataFromDom(handle) {
    const card = document.querySelector(`.cus-collection__card[data-product-handle="${CSS.escape(handle)}"]`);
    if (!card) return null;

    const title = card.querySelector('.cus-collection__product-title')?.textContent?.trim() || handle;
    const priceEl = card.querySelector('.custom-collection__price');
    const compareEl = card.querySelector('.custom-collection__compare-at-price');
    const delivery = card.querySelector('.cus-collection__card-delivery')?.textContent?.trim() || '';
    const icon = card.querySelector('.cus-collection__tags-svg')?.innerHTML?.trim() || '';

    let priceText = '';
    if (compareEl) {
      priceText = `${compareEl.textContent.trim()} ${priceEl?.textContent?.trim() || ''}`;
    } else if (priceEl) {
      priceText = priceEl.textContent.trim();
    }

    return { title, priceText, delivery, icon, url: card.querySelector('a')?.href || '#' };
  }

  function showResults() {
    let mapping = mappings.find((m) => m.goalIndex === answers[0]) || mappings[0];

    if (!mapping) {
      mapping = findHandlesForGoal(answers[0] ?? 0);
    }

    const titleEl = document.querySelector(SELECTORS.resultTitle);
    const subEl = document.querySelector(SELECTORS.resultSub);
    const listEl = document.querySelector(SELECTORS.resultList);

    if (titleEl) titleEl.textContent = mapping?.title || '';
    if (subEl) subEl.textContent = mapping?.sub || '';

    currentResultHandles = (mapping?.handles || []).slice(0, 3);

    if (listEl) {
      listEl.innerHTML = currentResultHandles
        .map((handle) => {
          const data = getProductDataFromDom(handle);
          if (!data) {
            return `<div class="hb-chatboot__result-item" data-hb-chatboot-result-item>
              <div class="hb-chatboot__result-item-icon">📦</div>
              <div>
                <div class="hb-chatboot__result-item-name">${handle}</div>
              </div>
            </div>`;
          }

          const metaParts = [data.priceText, data.delivery].filter(Boolean);
          const meta = metaParts.length ? metaParts.join(' · ') : '';

          return `<div class="hb-chatboot__result-item" data-hb-chatboot-result-item>
            <div class="hb-chatboot__result-item-icon">${data.icon || '📦'}</div>
            <div>
              <div class="hb-chatboot__result-item-name">${data.title}</div>
              ${meta ? `<div class="hb-chatboot__result-item-meta">${meta}</div>` : ''}
            </div>
          </div>`;
        })
        .join('');

      listEl.querySelectorAll('[data-hb-chatboot-result-item]').forEach((item) => {
        item.addEventListener('click', applyResults);
      });
    }

    document.querySelectorAll(SELECTORS.dot).forEach((d) => d.classList.add('done'));
    goStep(3);
  }

  function applyQuizToCollection(opts) {
    const api = window.HbCollectionFilter;
    if (!api?.setAiMatches || !persistentQuizHandles) return;

    api.setAiMatches(persistentQuizHandles);
    api.sortAiMatchesFirst?.();
    api.recomputeCardVisibilityFromRoot?.();

    const bar = document.querySelector('[data-hb-ai-bar]');
    const barText = document.querySelector('[data-hb-ai-bar-text]');
    if (bar) bar.hidden = false;
    if (barText) {
      barText.innerHTML = `<strong>✦ Based on your consultation</strong> <span class="hb-ai-bar-meta">${persistentQuizHandles.size} matched services below.</span>`;
    }

    if (opts?.scroll !== false) scrollToResults();
  }

  /** Bring the "Based on your consultation" bar + matched services under the header. */
  function scrollToResults() {
    const bar = document.querySelector('[data-hb-ai-bar]');
    const target = bar && !bar.hidden ? bar : document.querySelector('.cus-collection__wrapper');
    if (!target) return;
    if (window.BzScroll) {
      window.BzScroll.to(target);
    } else {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  function applyResults() {
    closeQuiz();

    const api = window.HbCollectionFilter;
    if (!api?.setAiMatches) {
      window.location.href = window.location.pathname;
      return;
    }

    persistentQuizHandles = new Set(currentResultHandles);
    document.dispatchEvent(new CustomEvent('hb-quiz-applied', { bubbles: true }));

    const filterRoot = document.querySelector('[data-collection-filter-root]');
    const allTab = filterRoot?.querySelector('[js-all]');

    if (allTab && !allTab.classList.contains('active')) {
      // The "All" list reloads first; the results are applied once it lands
      // (see the hb-collection-dom-refreshed listener), then we scroll.
      document.addEventListener('hb-collection-dom-refreshed', () => scrollToResults(), { once: true });
      allTab.click();
    } else {
      applyQuizToCollection({ scroll: true });
    }
  }

  function restartQuiz() {
    answers = [null, null, null];
    currentResultHandles = [];

    document.querySelectorAll(SELECTORS.option).forEach((o) => o.classList.remove('selected'));
    document.querySelectorAll(SELECTORS.nextBtn).forEach((b) => (b.disabled = true));
    document.querySelectorAll(SELECTORS.dot).forEach((d) => d.classList.remove('done'));

    goStep(0);
  }

  function init() {
    loadMappings();

    const section = getSection();
    if (!section) return;

    const openBtn = section.querySelector(SELECTORS.openBtn);
    const closeBtn = section.querySelector(SELECTORS.closeBtn);
    const overlay = section.querySelector(SELECTORS.overlay);

    openBtn?.addEventListener('click', openQuiz);
    closeBtn?.addEventListener('click', closeQuiz);
    overlay?.addEventListener('click', closeQuizBg);

    section.querySelectorAll(SELECTORS.option).forEach((opt) => {
      opt.addEventListener('click', () => {
        const step = parseInt(opt.dataset.step, 10);
        const value = opt.dataset.value;
        pickOption(step, value, opt);
        if (step === 2) {
          showResults();
        } else {
          goStep(step + 1);
        }
      });
    });

    section.querySelectorAll(SELECTORS.nextBtn).forEach((btn) => {
      btn.addEventListener('click', () => {
        const step = parseInt(btn.getAttribute('data-hb-chatboot-next'), 10);
        if (step === 2) {
          showResults();
        } else {
          goStep(step + 1);
        }
      });
    });

    section.querySelectorAll(SELECTORS.backBtn).forEach((btn) => {
      btn.addEventListener('click', () => {
        const step = parseInt(btn.getAttribute('data-hb-chatboot-back'), 10);
        goStep(step - 1);
      });
    });

    section.querySelector(SELECTORS.restartBtn)?.addEventListener('click', restartQuiz);
    section.querySelector(SELECTORS.browseBtn)?.addEventListener('click', applyResults);

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeQuiz();
    });

    document.addEventListener('hb-collection-dom-refreshed', () => {
      if (persistentQuizHandles !== null) {
        applyQuizToCollection({ scroll: false });
      }
    });

    document.addEventListener('hb-ai-search-cleared', () => {
      persistentQuizHandles = null;
    });

    document.addEventListener('hb-ai-search-applied', () => {
      persistentQuizHandles = null;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
